import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Box, FormControl, InputLabel, Select, MenuItem, CircularProgress, Grid } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

// New Modular Components & Hook
import {
    useAppointmentForm,
    CustomerAutocomplete,
    NewDeviceFields
} from '../../modules/appointments';

// New Imports for CustomerFormModal and related services
import CustomerFormModal from './CustomerFormModal';
import { createCustomer } from '../../services/customerService';

const hizmetler = ['Muayene', 'Kontrol', 'Cihaz Tamiri', 'Ödeme', 'Diğer', 'Uyku Testi', 'Maske Denemesi'];

const GeneralRandevuFormModal = ({ isOpen, onClose, randevuToEdit }) => {
    const {
        customers,
        selectedCustomer,
        customerInputValue,
        setCustomerInputValue,
        telefon,
        setTelefon,
        addDevice,
        setAddDevice,
        seriNumarasi,
        setSeriNumarasi,
        marka,
        setMarka,
        model,
        setModel,
        brandsFromDb,
        cihazSinifi,
        setCihazSinifi,
        isSgk,
        setIsSgk,
        zimmetTarihi,
        setZimmetTarihi,
        faturaNo,
        setFaturaNo,
        verilisTarihi,
        setVerilisTarihi,
        garantiBaslangic,
        setGarantiBaslangic,
        garantiBitis,
        setGarantiBitis,
        periyodikBakimTarihi,
        setPeriyodikBakimTarihi,
        randevuTarihi,
        setRandevuTarihi,
        ilgilenilenHizmet,
        setIlgilenilenHizmet,
        notlar,
        setNotlar,
        isSaving,
        handleCustomerChange,
        handleSubmit,
        handleClose,
        isEditing
    } = useAppointmentForm(isOpen, onClose, randevuToEdit);

    // Yeni Müşteri Modal State
    const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false);

    const handleAddNewCustomer = async (customerData) => {
        try {
            const customerId = await createCustomer(customerData);
            // Yeni oluşturulan müşteriyi seçmek için hook'tan gelen handleCustomerChange'i kullanıyoruz
            handleCustomerChange(null, { id: customerId, ...customerData });
            setIsCustomerModalOpen(false);
        } catch (error) {
            console.error("Müşteri oluşturma hatası:", error);
            alert("Müşteri oluşturulurken bir hata meydana geldi.");
        }
    };

    return (
        <>
            <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>{isEditing ? `Randevuyu Düzenle: ${randevuToEdit?.musteriAdSoyad}` : 'Yeni Randevu Oluştur'}</DialogTitle>
                <DialogContent>
                    <Box component="form" noValidate sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 3 }}>

                        <Grid container spacing={1} alignItems="flex-start">
                            <Grid item xs={10}>
                                <CustomerAutocomplete
                                    customers={customers}
                                    selectedCustomer={selectedCustomer}
                                    handleCustomerChange={handleCustomerChange}
                                    customerInputValue={customerInputValue}
                                    setCustomerInputValue={setCustomerInputValue}
                                    isEditing={isEditing}
                                    telefon={telefon}
                                    setTelefon={setTelefon}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Button
                                    fullWidth
                                    variant="outlined"
                                    sx={{ height: 56 }}
                                    onClick={() => setIsCustomerModalOpen(true)}
                                    title="Yeni Müşteri Ekle"
                                >
                                    <PersonAddIcon />
                                </Button>
                            </Grid>
                        </Grid>

                        {!selectedCustomer && customerInputValue && !isEditing && (
                            <NewDeviceFields
                                addDevice={addDevice}
                                setAddDevice={setAddDevice}
                                seriNumarasi={seriNumarasi}
                                setSeriNumarasi={setSeriNumarasi}
                                marka={marka}
                                setMarka={setMarka}
                                model={model}
                                setModel={setModel}
                                cihazSinifi={cihazSinifi}
                                setCihazSinifi={setCihazSinifi}
                                isSgk={isSgk}
                                setIsSgk={setIsSgk}
                                zimmetTarihi={zimmetTarihi}
                                setZimmetTarihi={setZimmetTarihi}
                                faturaNo={faturaNo}
                                setFaturaNo={setFaturaNo}
                                verilisTarihi={verilisTarihi}
                                setVerilisTarihi={setVerilisTarihi}
                                garantiBaslangic={garantiBaslangic}
                                setGarantiBaslangic={setGarantiBaslangic}
                                garantiBitis={garantiBitis}
                                setGarantiBitis={setGarantiBitis}
                                periyodikBakimTarihi={periyodikBakimTarihi}
                                setPeriyodikBakimTarihi={setPeriyodikBakimTarihi}
                                brandsFromDb={brandsFromDb}
                            />
                        )}

                        <DateTimePicker
                            label="Randevu Tarihi ve Saati *"
                            value={randevuTarihi}
                            onChange={setRandevuTarihi}
                            ampm={false}
                            minutesStep={15}
                        />

                        <FormControl fullWidth>
                            <InputLabel>İlgilenilen Hizmet</InputLabel>
                            <Select value={ilgilenilenHizmet} label="İlgilenilen Hizmet" onChange={(e) => setIlgilenilenHizmet(e.target.value)}>
                                {hizmetler.map(h => <MenuItem key={h} value={h}>{h}</MenuItem>)}
                            </Select>
                        </FormControl>

                        <TextField
                            label="Randevu Notları"
                            value={notlar}
                            onChange={(e) => setNotlar(e.target.value)}
                            multiline
                            rows={4}
                            placeholder="Örn: Cihazın periyodik bakımı hakkında görüşülecek."
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: '16px 24px' }}>
                    <Button onClick={handleClose} disabled={isSaving}>İptal</Button>
                    <Button onClick={handleSubmit} variant="contained" disabled={isSaving}>
                        {isSaving ? <CircularProgress size={24} /> : (isEditing ? 'Güncelle' : 'Kaydet')}
                    </Button>
                </DialogActions>
            </Dialog>

            <CustomerFormModal
                isOpen={isCustomerModalOpen}
                onClose={() => setIsCustomerModalOpen(false)}
                onAddCustomer={handleAddNewCustomer}
                customerToEdit={null}
            />
        </>
    );
};

export default GeneralRandevuFormModal;
